import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Image from 'components/Image';
import { useScrollRestore } from 'hooks';
import {
  ProjectContainer,
  ProjectSection,
  ProjectSectionContent,
  ProjectImage,
  ProjectTextRow,
  ProjectSectionHeading,
  ProjectSectionText,
  ProjectHeader,
  ProjectSectionColumns,
} from 'components/ProjectLayout';
import sliceApp from 'customAssets/twickCollage1.jpg';
import sliceAppPlaceholder from 'assets/slice-app-placeholder.jpg';
import sliceSidebarLayers from 'assets/unimaps/uni1.png';
import sliceSidebarLayersPlaceholder from 'assets/slice-sidebar-layers-placeholder.png';
import sliceSidebarAnnotations from 'assets/unimaps/uni2.png';
import sliceSidebarAnnotationsPlaceholder from 'assets/slice-sidebar-annotations-placeholder.png';
import sliceSlides from 'customAssets/twickCollage2.jpg';
import sliceSlidesPlaceholder from 'assets/slice-slides-placeholder.jpg';

import { media } from 'utils/style';
import './index.css';
import { EndFooter } from 'pages/Home/footer/footer';
import { appJoxDescription, appJoxTitle } from 'pages/Home';

const title = 'Because College Events are ❤️';
const description =
  'Unimaps is a groundbreaking startup funded by ASU, aimed at connecting ASU students with various clubs and organizations on campus and making college events an important part of college life.';
const roles = [
  'Product Architecture',
  'UX and UI Design',
  'Front End Development',
  'Back End Development',
];

const Unimaps = () => {
  useScrollRestore();

  return (
    <Fragment>
      <Helmet>
        <title>{`Projects | ${title}`}</title>
        <meta name="description" content={description} />
        <meta name="og:description" content={description} />
        <meta
          property="og:image"
          content="https://i.ibb.co/WtQsRdm/Screenshot-2022-02-15-204105.png"
        />{' '}
        <meta property="og:title" content={`Projects | ${title}`} />
        <meta name="twitter:description" content={appJoxDescription} />
        <meta name="twitter:title" content={appJoxTitle} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://i.ibb.co/WtQsRdm/Screenshot-2022-02-15-204105.png"
        />
      </Helmet>
      <ProjectContainer className="slice">
        <ProjectHeader title={title} description={description} roles={roles} />
        <ProjectSection first>
          <ProjectSectionContent></ProjectSectionContent>
        </ProjectSection>
        <ProjectSection>
          <ProjectSectionColumns centered className="slice__columns">
            <div className="sidebar__images-text">
              <ProjectSectionHeading>Backed by Arizona State University</ProjectSectionHeading>
              <ProjectSectionText>
                Unimaps is an innovative startup that aims to revolutionize the way
                students engage with clubs and organizations on university campuses.
                Funded by ASU.
              </ProjectSectionText>
              <ProjectSectionText>
                Unimaps has already made a significant impact on the ASU community, with
                over 75 clubs registered for the platform.
              </ProjectSectionText>
            </div>
            <div className="slice__sidebar-images">
              <Image
                className="slice__sidebar-image"
                srcSet={sliceSidebarLayers}
                placeholder={sliceSidebarLayersPlaceholder}
                alt="Unimaps App"
                sizes={`(max-width: ${media.mobile}px) 200px, 343px`}
              />
              <Image
                className="slice__sidebar-image"
                srcSet={sliceSidebarAnnotations}
                placeholder={sliceSidebarAnnotationsPlaceholder}
                alt="Unimaps App"
                sizes={`(max-width: ${media.mobile}px) 200px, 343px`}
              />
            </div>
          </ProjectSectionColumns>
        </ProjectSection>
        <ProjectSection light>
          
        </ProjectSection>
      </ProjectContainer>
      <EndFooter />
    </Fragment>
  );
};

export default Unimaps;
